import { render } from "./AGB.vue?vue&type=template&id=70d55024"
import script from "./AGB.vue?vue&type=script&lang=ts"
export * from "./AGB.vue?vue&type=script&lang=ts"
script.render = render

export default script